/**
 * Smart image helper, auto-upgrade any public-asset PNG URL to its WebP
 * sibling for browsers that support it (99%+ of users as of 2026). Falls
 * back gracefully to the original PNG on older browsers.
 *
 * Usage:
 *   import { SmartImg } from "../lib/smartImg";
 *   <SmartImg src="/assets/avatars/characters/dark_bald_blue.png" alt="..." />
 *
 * For cases where you need the string URL (e.g. CSS background-image) use
 * `webpOf(url)` directly.
 */
import React from "react";

export function webpOf(url) {
  if (!url || typeof url !== "string") return url;
  if (!url.toLowerCase().endsWith(".png")) return url;
  return url.replace(/\.png(\?|$)/i, ".webp$1");
}

export function SmartImg({ src, alt = "", ...rest }) {
  const webp = webpOf(src);
  if (webp === src) {
    return <img src={src} alt={alt} {...rest} />;
  }
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} {...rest} />
    </picture>
  );
}
